enum QueryKey {
    ACTIVITIES = 'activities',
    BANK = 'bank',
    COMPANIES = 'companies',
    COMPANY_COMMENTS = 'company-comments',
    COMPANY_CREDIT_CARDS = 'company-credit-cards',
    COMPANY_GROUPS = 'company-groups',
    COMPANY_VOUCHER_ASSIGNMENT = 'company-voucher-assignment',
    CREDIT_CARDS = 'credit-cards',
    CUSTOMER_EMPLOYEES = 'customer-employees',
    DASHBOARD_INVOICES = 'dashboard-invoices',
    DASHBOARD_PROCEDURE_EMPLOYEES = 'dashboard-procedure-employees',
    DASHBOARD_PROCEDURES = 'dashboard-procedures',
    DASHBOARD_TASKS = 'dashboard-tasks',
    DASHBOARD_TASKS_EMPLOYEES = 'dashboard-tasks-employees',
    DASHBOARD_TASKS_TEMPLATES = 'dashboard-tasks-templates',
    DASHBOARD_TASKS_VOUCHERS = 'dashboard-tasks-vouchers',
    DATA_FIELDS = 'data-fields',
    ECONOMIC_PROJECTS = 'economic-projects',
    EMPLOYEE_CHANGES_DATA = 'employee-changes-data',
    EMPLOYEE_DASHBOARD = 'employee-dashboard',
    EMPLOYEE_OPTIONALS = 'employee-optionals',
    EMPLOYEES = 'employees',
    HOLIDAY_PAY_OBLIGATIONS = 'holiday-pay-obligations',
    HOLIDAY_PAY_OBLIGATIONS_ENTRIES = 'holiday-pay-obligations-entries',
    HOLIDAYS = 'holidays',
    KEEPERS_EMPLOYEES_GROUPS = 'keepers-employees-groups',
    KUBE = 'kube',
    LOGS = 'logs',
    ONBOARDING = 'onboarding',
    ONBOARDING_SERVICES = 'onboarding-services',
    PAYROLL = 'payroll',
    PAYROLLS = 'salary-payrolls',
    POWER_BI = 'power-bi',
    POWER_BI_DATA = 'power-bi-data',
    ROLES = 'roles',
    ROLE_OPTIONS = 'role-options',
    SALARY_EMPLOYEES = 'salary-employees',
    SALARY_LOG = 'salary-log',
    SALARY_STATUS = 'salary-status',
    TASK_TEMPLATES = 'task-templates',
    TRANSACTIONS = 'transactions',
    USER_COMPANIES = 'user-companies',
    USER_GROUPS = 'user-groups',
    USERS = 'users',
    USERS_WITHOUT_EMPLOYEE = 'users-without-employee',
    VAT = 'vat',
    VAT_DEADLINES = 'vat-deadlines',
    VOUCHER_DEPARTMENTS_OPTIONS = 'voucher-departments-options',
    VOUCHERS = 'vouchers',
    VOUCHERS_EARLIER_RELEASES = 'vouchers-earlier-releases',
    WORK_CALENDARS = 'work-calendars',
}

export default QueryKey;
